import {SkeletonText, Table, TableBody, TableCell, TableContainer, TableHead, TableHeader, TableRow} from '@carbon/react';
import {useMemo} from 'react';
import {ISpecialty} from '../../types';

const ROWS = 16;
const PROVIDER = 'PROVIDER SPECIALTIES';
const FACILITY = 'FACILITY SPECIALTIES';
const className = 'specialty-groupings-table';

interface ISpecialtyGroupingsTableProps {
    providerSpecialties: ISpecialty[];
    facilitySpecialties: ISpecialty[];
    loading: boolean;
    error: string | null;
}
const SpecialtyGroupingsTable = (props: ISpecialtyGroupingsTableProps) => {

    const {providerSpecialties, facilitySpecialties, loading, error} = props;
    const specialtyGroupingsTableHeaders = useMemo(() => {
        return [
            {
                items: [
                    {label: PROVIDER, colSpan: 2},
                    {label: FACILITY}
                ]
            }
        ];
    }, []);

    return (
        <TableContainer>
            <Table className={className}>
                <TableHead>
                    {specialtyGroupingsTableHeaders.map((headerRow, i) => {
                        const {items, ...rest} = headerRow;
                        return (
                            <TableRow key={i} {...rest}>
                                {items.map((headerCell, index) => (
                                    <TableHeader key={index} colSpan={headerCell.colSpan || 1}>
                                        <div className='cds--table-header-label'>
                                            {headerCell.label}
                                        </div>
                                    </TableHeader>
                                ))}
                            </TableRow>
                        );
                    })}
                </TableHead>
                <TableBody>
                    {!!error && (
                        <TableRow>
                            <TableCell colSpan={3}>
                                <div className="error-message">{error}</div>
                            </TableCell>
                        </TableRow>
                    )}
                    {loading && [...Array(ROWS)].map((_, index) => {
                        return (
                            <TableRow key={index}>
                                {[...Array(3)].map((_, cellIndex) => (
                                    <TableCell key={cellIndex} className="specialty-name">
                                        <SkeletonText />
                                    </TableCell>
                                ))}
                            </TableRow>
                        );
                    })}
                    {!loading && !error && [...Array(ROWS)].map((_, index) => {
                        return (
                            <TableRow key={index}>
                                <TableCell className="specialty-name">{providerSpecialties[index]?.specialty_name}</TableCell>
                                <TableCell className="specialty-name">{providerSpecialties[index + ROWS]?.specialty_name}</TableCell>
                                <TableCell className="specialty-name">{facilitySpecialties[index]?.specialty_name}</TableCell>
                            </TableRow>
                        );
                    })}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default SpecialtyGroupingsTable;
